import { FontAwesome, Ionicons } from "@expo/vector-icons";
import {
	Box,
	Heading,
	HStack,
	Icon,
	IconButton,
	Spinner,
	Text,
	Tooltip,
	useMediaQuery,
	useTheme,
	VStack,
} from "native-base";
import React from "react";
import {
	ScrollView,
	View,
	TouchableOpacity,
	FlatList,
	Image,
	Dimensions,
} from "react-native";
import { useDispatch, useSelector } from "react-redux";
import { currencyFormat } from "../../components/dynamic/ComponentsGenerator";
import LoadingIndicator from "../../components/LoadingIndicator";
import TableRow from "../../components/TableRow";
import { getBalance } from "../../redux/slices/BalanceSlice";
import { getCardBalance } from "../../redux/slices/CardBalanceSlice";
import { getIncentivePayouts } from "../../redux/slices/IncentivePayoutSlice";
import RenderHtml from "react-native-render-html";
import { decode as atob, encode as btoa } from "base-64";
import { getIncentiveNoticeBoard } from "../../redux/slices/IncentiveNoticeBoardSlice";
import { isWeb } from "../../utils/utils";
import WebView from "react-native-webview";
const { width, height } = Dimensions.get("window");

const MainMenu = ({ navigation, route }) => {
	const { colors } = useTheme();
	const isDesktopOrLaptop = useMediaQuery({ minWidth: 960 })[0];

	const Auth = useSelector((state) => state.Login.Auth);
	const CardBalance = useSelector((state) => state.cardBalance.Balance);
	const isCardBalanceLoading = useSelector(
		(state) => state.cardBalance.loading
	);
	const HasLinkedCard = useSelector((state) => state.cardBalance.hasLinkedCard);

	const { profile } = Auth;
	let { data, role, stores } = profile;

	const dispatch = useDispatch();

	React.useEffect(() => {
		fetchBalance();
	}, [route]);

	const fetchBalance = async () => {
		dispatch(getBalance());
		dispatch(getCardBalance());
	};

	React.useEffect(() => {
		dispatch(getIncentivePayouts());
		dispatch(getIncentiveNoticeBoard(isWeb()));
	}, []);

	const balance = useSelector((state) => state.balance.Balance);
	const loading = useSelector((state) => state.balance.loading);
	const Payouts = useSelector((state) => state.Payout.Payouts);
	const isLoading = useSelector((state) => state.Payout.loading);
	const NoticeBoard = useSelector((state) => state.NoticeBoard.Notice);
	const isNoticeLoading = useSelector((state) => state.NoticeBoard.loading);

	return (
		<ScrollView style={{ flex: 1 }}>
			{isDesktopOrLaptop && (
				<Box
					borderRadius="4"
					w="100%"
					bg="#fff"
					mb={5}
					mt={isDesktopOrLaptop ? "0" : "2"}
					style={{
						padding: 5,
						border: "1px solid #dedede",
					}}
				>
					<VStack space="2">
						<Text>
							<Text fontWeight="900">WELCOME </Text>
							{`${Auth.profile.data
								.filter((profile) => profile.type_name === "first_name")[0]
								?.data_text?.toUpperCase()} ${Auth.profile.data
								.filter((profile) => profile.type_name === "second_name")[0]
								?.data_text?.toUpperCase()}`}
						</Text>
					</VStack>
				</Box>
			)}
			{isDesktopOrLaptop && (
				<View
					style={{
						flexDirection: "row",
						justifyContent: "space-between",
						marginBottom: 20,
					}}
				>
					<Text>
						<Text fontWeight="900">My Wallet Balance: </Text>
						{currencyFormat(balance / 100)}
					</Text>
					<Text>
						<Text fontWeight="900">My Card Balance: </Text>
						{HasLinkedCard
							? currencyFormat(CardBalance / 100)
							: "No Card Linked"}
					</Text>
					<Text>
						<Text fontWeight="900">My Member role: </Text>
						{Auth.profile.role}
					</Text>
				</View>
			)}
			{!isDesktopOrLaptop && (
				<>
					<Box
						borderRadius="10"
						w="100%"
						bg="#fff"
						mb={2}
						mt={isDesktopOrLaptop ? "0" : "2"}
						style={{
							shadowOffset: { width: 0.5, height: 0.2 },
							shadowOpacity: 0.7,
							shadowRadius: 1,
							shadowColor: "#d5d5d5",
						}}
					>
						<VStack space="2">
							<TableRow
								title={`${Auth.profile.data
									.filter((profile) => profile.type_name === "first_name")[0]
									?.data_text?.toUpperCase()} ${Auth.profile.data
									.filter((profile) => profile.type_name === "second_name")[0]
									?.data_text?.toUpperCase()}`}
								value={role?.toUpperCase()}
								borderBottomWidth="0"
							/>
						</VStack>
					</Box>
					<View
						style={{
							margin: 5,
						}}
					>
						<Heading fontWeight="900" size="md" color="primary.500">
							Balances
						</Heading>
					</View>

					<View
						style={{
							flexDirection: "row",
							justifyContent: "space-between",
							marginTop: 10,
							marginHorizontal: 5,
						}}
					>
						<Box
							border="1"
							borderRadius="10"
							w="48%"
							mb={5}
							bg="#fff"
							style={{
								padding: 5,
								border: "1px solid #dedede",
								shadowOffset: { width: 0.5, height: 0.2 },
								shadowOpacity: 0.7,
								shadowRadius: 1,
								shadowColor: "#d5d5d5",
							}}
						>
							<View>
								<View
									style={{
										padding: 5,
										flexDirection: "row",
										alignItems: "center",
										justifyContent: "space-between",
										borderTopEndRadius: 10,
										borderTopStartRadius: 10,
									}}
								>
									<Text fontWeight="800">Wallet Balance</Text>
									<IconButton
										onPress={() => dispatch(getBalance())}
										isLoading={loading}
										isLoadingText="Loading..."
										variant="ghost"
										_icon={{
											as: FontAwesome,
											name: loading ? "circle-o-notch" : "refresh",
											size: "sm",
											color: colors.primary["500"],
										}}
									/>
								</View>
								<Box p="2">
									<Text fontWeight="900" fontSize="22">
										{currencyFormat(balance / 100)}{" "}
									</Text>
								</Box>
							</View>
						</Box>
						<Box
							border="1"
							borderRadius="10"
							w="48%"
							mb={5}
							bg="#fff"
							style={{
								padding: 5,
								border: "1px solid #dedede",
								shadowOffset: { width: 0.5, height: 0.2 },
								shadowOpacity: 0.7,
								shadowRadius: 1,
								shadowColor: "#d5d5d5",
							}}
						>
							<View>
								<View
									style={{
										padding: 5,
										flexDirection: "row",
										alignItems: "center",
										justifyContent: "space-between",
										borderTopEndRadius: 10,
										borderTopStartRadius: 10,
									}}
								>
									<Text fontWeight="900">Card Balance</Text>
									<IconButton
										onPress={() => dispatch(getCardBalance())}
										variant="ghost"
										_icon={{
											as: FontAwesome,
											name: isCardBalanceLoading ? "circle-o-notch" : "refresh",
											size: "sm",
											color: colors.primary["500"],
										}}
									/>
								</View>
								<Box p="2">
									<Text fontWeight="800" fontSize="22">
										{HasLinkedCard
											? currencyFormat(CardBalance / 100)
											: "No Card Linked"}
									</Text>
								</Box>
							</View>
						</Box>
					</View>
				</>
			)}
			<>
				<View
					style={{
						flex: 1,
						flexDirection: isDesktopOrLaptop ? "row" : "column",
						justifyContent: "space-between",
					}}
				>
					<View
						style={
							isDesktopOrLaptop
								? {
										flex: 1,
										marginRight: 30,
								  }
								: { marginRight: 5 }
						}
					>
						{NoticeBoard?.content_base64 && (
							<>
								<View
									style={{
										borderBottomWidth: 2,
										borderBottomColor: "#D5D5D5",
										margin: 5,
									}}
								>
									<Heading fontWeight="900" size="md" color="primary.500">
										NOTICE BOARD
									</Heading>
								</View>
								<View
									style={{
										padding: 10,
										backgroundColor: "#fff",
										marginVertical: 10,
										borderRadius: 10,
										border: "1px solid #dedede",
									}}
								>
									{isNoticeLoading ? (
										<View
											style={{
												flexDirection: "row",
												alignItems: "center",
												justifyContent: "center",
											}}
										>
											<IconButton
												isDisabled={true}
												title="Loading..."
												variant="ghost"
												_icon={{
													as: FontAwesome,
													name: "circle-o-notch",
													size: "sm",
													color: colors.primary["500"],
												}}
											/>
											<Text color={colors.primary["500"]}>Loading...</Text>
										</View>
									) : (
										// <Spinner accessibilityLabel="Loading" />
										<>
											{isWeb() ? (
												<RenderHtml
													contentWidth={300}
													source={{
														html: NoticeBoard?.content_base64
															? atob(NoticeBoard?.content_base64)
															: "",
													}}
												/>
											) : (
												<View style={{ height: height / 1.6 }}>
													<WebView
														automaticallyAdjustContentInsets={false}
														// containerStyle={{ height: height / 1.6 }}
														originWhitelist={["*"]}
														source={{
															html: NoticeBoard?.content_base64
																? atob(NoticeBoard?.content_base64)
																: "",
														}}
													/>
												</View>
											)}
										</>
									)}
								</View>
							</>
						)}
					</View>

					<View style={{ flex: 1 }}>
						<View
							style={{
								marginVertical: 20,
								marginHorizontal: 5,
							}}
						>
							<Heading
								size="sm"
								color="primary.500"
								fontWeight={400}
								alignSelf={isDesktopOrLaptop ? "center" : null}
							>
								INCENTIVE PAYOUTS
							</Heading>
							<Text fontSize={12}>
								The following devices can be claimed against at your store. The
								incentive amounts displayed below are based on current
								transaction/invoice dates, and are subjected to change:
							</Text>
						</View>
						<View>
							{isLoading ? (
								<View
									style={{
										flexDirection: "row",
										alignItems: "center",
										justifyContent: "center",
									}}
								>
									<IconButton
										isDisabled={true}
										title="Loading..."
										variant="ghost"
										_icon={{
											as: FontAwesome,
											name: "circle-o-notch",
											size: "sm",
											color: colors.primary["500"],
										}}
									/>
									<Text color={colors.primary["500"]}>Loading...</Text>
								</View>
							) : (
								<FlatList
									refreshing={isLoading}
									data={Payouts}
									numColumns={2}
									keyExtractor={(item) => item.productincentive_guid}
									renderItem={({ item, index }) => (
										<View
											style={
												isDesktopOrLaptop
													? {
															// flex: 0.5,
															width: width / 5.3,
															backgroundColor: "#fff",
															padding: 5,
															margin: 5,
															borderRadius: 5,
															border: "1px solid #dedede",
															shadowOffset: { width: 0.5, height: 0.2 },
															shadowOpacity: 0.7,
															shadowRadius: 1,
															shadowColor: "#d5d5d5",
													  }
													: {
															// flex: 0.5,
															width: width / 2.2,
															backgroundColor: "#fff",
															padding: 5,
															margin: 5,
															borderRadius: 5,
															border: "1px solid #dedede",
															shadowOffset: { width: 0.5, height: 0.2 },
															shadowOpacity: 0.7,
															shadowRadius: 1,
															shadowColor: "#d5d5d5",
													  }
											}
										>
											<Tooltip label={item.product_name} openDelay={500}>
												<View
													style={{
														// flex: 1,
														flexDirection: "row",
														alignItems: "center",
													}}
												>
													<View>
														<Image
															resizeMode="contain"
															source={{
																uri: `data:image/png;base64,${item.thumbnail_base64}`,
															}}
															style={{
																width: 50,
																height: 50,
																resizeMode: "contain",
															}}
														/>
													</View>
													<View style={{ flex: 1 }}>
														<Text fontSize={16} fontWeight="900">
															{item.product_name}
														</Text>
														<Text fontSize={10} numberOfLines={2}>
															<Text
																fontSize={12}
																color={"#D61D1D"}
																fontWeight="900"
															>
																{currencyFormat(
																	Number(item.incentive_value) / 100
																)}{" "}
															</Text>
															to be earned
														</Text>
													</View>
												</View>
											</Tooltip>
										</View>
									)}
									ListEmptyComponent={() => (
										<View
											style={{
												backgroundColor: "#fff",
												padding: 5,
												flex: 1,
												margin: 5,
												borderRadius: 5,
												border: "1px solid #dedede",
												shadowOffset: { width: 0.5, height: 0.2 },
												shadowOpacity: 0.7,
												shadowRadius: 1,
												shadowColor: "#d5d5d5",
											}}
										>
											<Text>No Incentive Payouts</Text>
										</View>
									)}
								/>
							)}
						</View>
					</View>
				</View>
			</>
		</ScrollView>
	);
};

export default MainMenu;
